import { FileUpload as FileUploadIcon, Edit as EditIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, Card, Checkbox, IconButton } from '@mui/material';
import { useState } from 'react';
import AILoader from './ai-loader.component';

const ImageGeneratedComponent = ({ isGeneratingImage, generatedImages, uploadToNewPost, handleEdit }) => {
  const [isUploadToNewPostClicked, setUploadToNewPostClicked] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleSelectFile = (event, media) => {
    let files = [...selectedFiles];
    let isChecked = event.target.checked;
    if (isChecked) {
      files.push(media);
    } else {
      let index = files.findIndex((a) => a.media_url === media.media_url);
      if (index >= 0) {
        files.splice(index, 1);
      }
    }
    setSelectedFiles(files);
  };

  return (
    <Box sx={{ height: '90vh', display: 'flex', flexDirection: 'column' }}>
      <Card sx={{ flex: 1, p: 3, overflow: 'scroll' }}>
        {isGeneratingImage ? (
          <AILoader />
        ) : (
          <>
            {selectedFiles?.length > 0 && (
              <LoadingButton
                variant="contained"
                loading={isUploadToNewPostClicked}
                endIcon={<FileUploadIcon />}
                onClick={() => {
                  setUploadToNewPostClicked(true);
                  uploadToNewPost(selectedFiles);
                }}
                style={{
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
                  px: 3,
                  marginBottom: 10,
                }}
              >
                Upload to New Post
              </LoadingButton>
            )}
            {generatedImages?.length > 0 &&
              generatedImages?.map((media) => {
                return (
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: 2,
                      boxShadow: 1,
                      cursor: 'pointer',
                      flex: '0 0 auto',
                      marginBottom: 25,
                    }}
                  >
                    <img
                      src={media.media_url}
                      alt={media.media_url}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        cursor: 'pointer',
                      }}
                    />
                    <Box
                      className="overlay"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        transition: 'opacity 0.3s',
                        display: "flex"
                      }}
                    >
                      <Checkbox
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 30,
                            backgroundColor: 'white',
                            borderRadius: '20%',
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            },
                          },
                        }}
                        onChange={(e) => handleSelectFile(e, media)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <IconButton
                        size="large"
                        sx={{
                          backgroundColor: 'rgba(0, 0, 0, 0.5)', // or any semi-transparent bg
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          },
                        }}
                        onClick={() => {
                          handleEdit([media], true);
                        }}
                      >
                        <EditIcon sx={{ color: '#fff' }} />
                      </IconButton>
                    </Box>
                  </div>
                );
              })}
          </>
        )}
      </Card>
    </Box>
  );
};
export default ImageGeneratedComponent;
